import React, { useEffect, useContext } from "react";
import FifoTabs from "../../components/_fifoTabs";
import RoleChecker from "../../../../utils/roleChecker";
import authService from "../../../../services/authService";
import EntityContext from "../../../../context/entityContext";
import NoAccess from "../../widgets/noAccess";
import { browserHistory } from "react-router";
import { Helmet } from "react-helmet";
import ProcessingFacility from "../../widgets/general/processingFacility";
import { SupplyChainProvider, SupplyChainContext } from "../../../../context/supplyChainContext";

// export default function SCFLayout (props) {
    

const SCFLayout = (props) => {
    const { children, location } = props;

    const { handleProductChange, selectedBusinessType, handleRoleChange, selProduct, accountDetails, entityDetails } = useContext(EntityContext);
    const { constants, products } = authService.getCurrentUser();
    const { productId } = useContext(SupplyChainContext);

    useEffect(() => {

        handleProductChange(constants.PRODUCTS.SUPPLYCHAIN);

        if(selectedBusinessType === null || selectedBusinessType === 'ALL'){
            if(RoleChecker.check(products, constants.ROLES.CUSTOMER))
                handleRoleChange(constants.BUSINESS_TYPE.PURCHASE);
            else if(RoleChecker.check(products, constants.ROLES.SUPPLIER))
                handleRoleChange(constants.BUSINESS_TYPE.SALE);
            else
                browserHistory.push('/client/home')
        }

    }, []);

    const accountInfo = accountDetails.find(item => item.product == constants.PRODUCTS.SUPPLYCHAIN);
    const productSettings = entityDetails.productSettings.find(item => item.id == constants.PRODUCTS.SUPPLYCHAIN);

    return(
        <div>
            { ( ( props.location.query && props.location.query.type === 'sale') && selProduct === constants.PRODUCTS.SUPPLYCHAIN ) ?
                <>
                    <FifoTabs 
                        activePath={props.location.pathname.substring(
                            props.location.pathname
                        )} 
                    />
                    {props.children}
                </> 
             :
            <>
            {( (!accountInfo || !productSettings.default_settings_available) && selectedBusinessType === constants.BUSINESS_TYPE.PURCHASE  ) ? (
               <ProcessingFacility />
            ) :
            selProduct === constants.PRODUCTS.SUPPLYCHAIN ? 
                <>
                    <Helmet>
                        <title>{accountInfo ? accountInfo.nick_name ? accountInfo.nick_name : accountInfo.bank_account_name : ''} | {global.config.title}</title>
                    </Helmet>
                    <FifoTabs 
                        activePath={props.location.pathname.substring(
                            props.location.pathname
                        )} 
                    />
                    {props.children}
                </> 
                : 
                <NoAccess />
            }
            </> }
        </div>
    )    
}


const WrappedSupplyChainLayout = (props) => (
  <SupplyChainProvider>
    <SCFLayout {...props} />
  </SupplyChainProvider>
);

export default WrappedSupplyChainLayout;